import React from "react"
// xl:max-w-[300px]
const CardWrapper = ({ children }) => {
  return (
    <div className="w-full flex-1">
      <div className="relative bg-white rounded-md shadow-md px-3 py-1">{children}</div>
    </div>
  )
}

export default CardWrapper
